import { LoadIndicator } from 'devextreme-react';
import { Button } from 'devextreme-react/button';
import { DateRangeBox } from 'devextreme-react/date-range-box';
import TagBox from 'devextreme-react/tag-box';
import * as ExcelJS from 'exceljs';
import saveAs from 'file-saver';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Card, CardBody, CardFooter, Col, Row } from 'reactstrap';
import Breadcrumb from '../../../components/common/breadcrumb';
import api from '../../../services/api-configuration';
import apii from '../../../services/api-configuration-v3.js';
import { getAllWarehouses } from '../../../services/apis';

// Kolon konfigürasyonları
const COLUMN_CONFIGS = {
    shipmentPending: [
        { field: 'chassis_no', header: 'Şase' },
        { field: 'color_name', header: 'Renk' },
        { field: 'marka', header: 'Marka' },
        { field: 'model', header: 'Model' },
        { field: 'ship_name', header: 'Gemi Adı' },
        { field: 'unload_date', header: 'Tahliye Tarihi' },
        { field: 'unload_warehouse', header: 'Tahliye Depo' },
        { field: 'user_name', header: 'Kullanıcı' }
    ],
    pdiIncoming: [
        // sase	marka	model adı (kısa)	depo	parkadres(pdigirisoncesi)	işlemtarihi	işlemiyapanuser	
        { field: 'chassis_no', header: 'Şase' },
        { field: 'marka', header: 'Marka' },
        { field: 'model', header: 'Model' },
        { field: 'depo', header: 'Depo' },
        { field: "address_information", header: "Park Adres" },
        { field: 'pdi_entry_date', header: 'İşlem Tarihi' },
        { field: 'user_name', header: 'İşlemi Yapan' }
    ],
    pdiOutgoing: [
        // sase	marka	model adı (kısa)	depo	parkadres(pdicikissonrasi)	işlemtarihi	işlemiyapanuser	
        { field: 'chassis_no', header: 'Şase' },
        { field: 'marka', header: 'Marka' },
        { field: 'model', header: 'Model' },
        { field: 'depo', header: 'Depo' },
        { field: "address_information", header: "Park Adres" },
        { field: 'pdi_exit_date', header: 'İşlem Tarihi' },
        { field: 'user_name', header: 'İşlemi Yapan' }
    ],
    warehouseOutgoing: [
        // grupaj numarası	sevkiyat tipi	sevkbölgesi	rota	sase	marka	model adı (kısa)	model adı (uzun)	renk	çıktığı depo	gittiğibayi/özeladres (uzun ismi)	sevk ili	taşıyıcıfirma	tırplakası	dorseplakası	şoföradı	faturabilgisigeldigitarih	grupajyapildigitarih	pditarihi	tireslemetarihi	fatura tarihi	pdi (evet/hayır)	milli (evet/hayır)
        { field: 'grupaj_no', header: 'GrupajNo' },
        { field: 'type_name', header: 'SevkiyatTipiAdi' },
        { field: 'rota', header: 'Rota' },
        { field: 'sasi', header: 'Şase' },
        { field: 'grupaj_yapildigi_tarih', header: 'GrupajTarih' },
        { field: 'fatura_bilgisi_tarihi', header: 'BilgiGelisTarih' },
        { field: 'tir_esleme_tarihi', header: 'TirEslemeTarih' },
        { field: 'kapi_cikis_tarihi', header: 'KapiCikisTarih' },
        { field: 'tasiyici_firma', header: 'TaseronFirmaAdi' },
        { field: 'sofor_adi', header: 'TirSoforAdiSoyadi' },
        { field: 'tir_plaka', header: 'TirPlaka' },
        { field: 'dorse_plaka', header: 'DorsePlaka' },
        { field: 'ciktigi_depo', header: 'FromLokasyonAdi' },
        { field: 'gittigi_bayi', header: 'JustToLokasyonAdi' },
        { field: 'city_name', header: 'ToLokasyonIl' },
        { field: 'PDI EVET/HAYIR', header: 'PDI (Evet/Hayır)' },
        { field: 'marka', header: 'Marka' },
        { field: 'model_uzun', header: 'Model (Uzun)' },
        { field: 'model', header: 'Model (kısa)' },
        { field: 'Araç Tipi', header: 'Araç Tipi' },
        { field: 'color_name', header: 'RenkAdi' },
        { field: 'region_name', header: 'ToLokasyonBolgeCode' },
        { field: 'fatura_tarihi', header: 'Fatura Tarihi' },
        { field: 'pdi_cikis_tarihi', header: 'PDI Tarihi' },
        { field: 'MİLLİ EVET/HAYIR', header: 'Milli (Evet/Hayır)' },
        { field: 'dealer_code', header: 'RRDI Code' }

    ],
    warehouseIncoming: [
        // sase	marka	model adı (kısa)	depo	parkadres(depogirissonrasi)	işlemtarihi	işlemiyapanuser	
        { field: 'chassis_no', header: 'Şase' },
        { field: 'marka', header: 'Marka' },
        { field: 'model', header: 'Model' },
        { field: 'arac_tipi', header: 'Araç Tipi' },
        { field: 'new_warehouse_name', header: 'Depo' },
        { field: 'park_address', header: 'Park Adres' },
        { field: 'islem_tarihi', header: 'İşlem Tarihi' },
        { field: 'user_name', header: 'İşlemi Yapan' }
    ],

    fatura:
        [
            // { field: 'tasiyici_firma', header: 'Taşıyıcı Firma' },
            { field: 'type_name', header: 'Sevkiyat Tipi' },
            { field: 'kapi_cikis_tarihi', header: 'Kapı Çıkış Tarihi' },
            { field: 'chassis_no', header: 'Şase' },
            { field: 'marka', header: 'Marka' },
            { field: 'model', header: 'Model' },
            { field: 'Araç Tipi', header: 'Araç Tipi' },
            { field: 'ciktigi_depo', header: 'Çıktığı Depo' },
            { field: 'gittigi_bayi', header: 'Gittiği Bayi' },
            { field: 'sevk_ili', header: 'Sevk İli' },
            { field: 'region_name', header: 'Sevk Bölgesi' },
            { field: 'grupaj_no', header: 'Grupaj Numarası' },
            { field: 'name', header: 'Taşıyıcı Firma' },
        ]
};

const RaporlarMusteri = () => {
    const [dateRange, setDateRange] = useState([new Date(), new Date()]);

    const [selectedWarehouse, setSelectedWarehouse] = useState(null);
    const [visibleLoader, setVisibleLoader] = useState({
        shipmentPending: null,
        pdiIncoming: null,
        pdiOutgoing: null,
        warehouseOutgoing: null,
        warehouseIncoming: null,
        saseList: null,
        fatura: null,
        bayiRaporu: null,
        gumrukluSahaCikis: null,
        ozelRapor: null
    });
    const [warehouses, setWarehouses] = useState([]);
    const [reportData, setReportData] = useState({});
    const [excelFiles, setExcelFiles] = useState({});
    const [downloadingFiles, setDownloadingFiles] = useState({});
    const [stats, setStats] = useState({
        shipmentPending: null,
        pdiIncoming: null,
        pdiOutgoing: null,
        warehouseOutgoing: null,
        warehouseIncoming: null,

        fatura: null

    });

    const REPORT_KEY = {
        shipmentPending: 8,
        pdiIncoming: 3,
        pdiOutgoing: 2,
        warehouseOutgoing: 4,
        warehouseIncoming: 6,

        fatura: 5,


    };

    useEffect(() => {
        const fetchWarehouses = async () => {
            try {
                const response = await getAllWarehouses();
                setWarehouses(response);
            } catch (error) {
                console.error('Error fetching warehouses:', error);
            }
        };

        fetchWarehouses();
    }, []);

    const handleDateChange = (e) => setDateRange(e.value);
    const handleWarehouseChange = (e) => setSelectedWarehouse(e.value);

    const fetchReport = async (reportKey, id) => {
        if (id === null) {
            setStats(prev => ({
                ...prev,
                [reportKey]: null
            }));
            setVisibleLoader(prev => ({
                ...prev,
                [reportKey]: false
            }));
            return;
        }

        try {
            // saseList için yeni API kullan, diğerleri için eski API
            if (reportKey === 'saseList') {
                const response = await apii.post('/reports/getExcelReport', {
                    startDate: moment(dateRange[0]).format('YYYY-MM-DD'),
                    endDate: moment(dateRange[1]).format('YYYY-MM-DD'),
                    warehouseIDs: selectedWarehouse || [],
                    reportID: id,
                    columnOrder: COLUMN_CONFIGS[reportKey].map(col => col.header)
                }, {
                    responseType: 'blob',
                    headers: {
                        'Accept': 'application/octet-stream',
                        'Content-Type': 'application/json'
                    }
                });

                // Excel dosyasını tut
                const blob = new Blob([response.data]);
                setExcelFiles(prev => ({
                    ...prev,
                    [reportKey]: blob
                }));

                // Row count'u al ve stats'e kaydet
                const rowCount = response.headers['x-row-count'];
                const count = rowCount ? parseInt(rowCount) : 0;

                setStats(prev => ({
                    ...prev,
                    [reportKey]: count
                }));
            } else {
                // Diğer raporlar için eski API
                const response = await api.post('/report', {
                    start_date: moment(dateRange[0]).format('YYYY-MM-DD'),
                    end_date: moment(dateRange[1]).format('YYYY-MM-DD'),
                    warehouse_ids: id === 9 ? [] : selectedWarehouse,
                    report_id: id
                });

                setReportData(prev => ({
                    ...prev,
                    [reportKey]: response.data || []
                }));

                setStats(prev => ({
                    ...prev,
                    [reportKey]: Array.isArray(response.data) ? response.data.length :
                        (response.data?.data === null ? 0 : response.data?.data.length)
                }));
            }

        } catch (error) {
            if (reportKey === 'saseList') {
                // saseList için yeni hata yönetimi
                const errorMessage = error.response?.data?.error || error.message || '';
                console.error(errorMessage);
                if (errorMessage.includes('empty data') || errorMessage.includes('failed to generate Excel')) {
                    setStats(prev => ({
                        ...prev,
                        [reportKey]: 0
                    }));
                    setExcelFiles(prev => {
                        const newState = { ...prev };
                        delete newState[reportKey];
                        return newState;
                    });
                } else {
                    setStats(prev => ({
                        ...prev,
                        [reportKey]: 'Hata'
                    }));
                    setExcelFiles(prev => {
                        const newState = { ...prev };
                        delete newState[reportKey];
                        return newState;
                    });
                    let message = error.response?.data?.error || 'Beklenmedik bir hata oluştu';
                    toast.error(message + ` (${reportKey})`);
                }
            } else {
                // Diğer raporlar için eski hata yönetimi
                console.error(`Error fetching ${reportKey} report:`, error);
                setStats(prev => ({
                    ...prev,
                    [reportKey]: 'Hata'
                }));
                let message = error.response?.data?.error || 'Beklenmedik bir hata oluştu';
                toast.error(message + ` (${reportKey})`);
            }
        } finally {
            setVisibleLoader(prev => ({
                ...prev,
                [reportKey]: false
            }));
        }
    };

    // First, let's modify the handleListele function
    const handleListele = async () => {
        // Remove the warehouse selection check
        if (!dateRange[0] || !dateRange[1]) {
            toast.error("Lütfen bir tarih aralığı seçiniz.");
            return;
        }

        // If no warehouse is selected, use all warehouse IDs
        const warehouseIdsToUse = selectedWarehouse?.length ? selectedWarehouse :
            warehouses.map(warehouse => warehouse.id);

        setStats(prev => Object.keys(prev).reduce((acc, key) => ({
            ...acc,
            [key]: REPORT_KEY[key] === null ? null : 0
        }), {}));

        const initialLoaders = Object.keys(visibleLoader).reduce((acc, key) => ({
            ...acc,
            [key]: REPORT_KEY[key] !== null
        }), {});
        setVisibleLoader(initialLoaders);

        // Update fetchReport function to use warehouseIdsToUse
        const fetchReportWithWarehouses = async (reportKey, id) => {
            if (id === null) {
                setStats(prev => ({
                    ...prev,
                    [reportKey]: null
                }));
                setVisibleLoader(prev => ({
                    ...prev,
                    [reportKey]: false
                }));
                return;
            }

            try {
                // saseList için yeni API kullan, diğerleri için eski API
                if (reportKey === 'saseList') {
                    const response = await apii.post('/reports/getExcelReport', {
                        startDate: moment(dateRange[0]).format('YYYY-MM-DD'),
                        endDate: moment(dateRange[1]).format('YYYY-MM-DD'),
                        warehouseIDs: warehouseIdsToUse,
                        reportID: id,
                        columnOrder: COLUMN_CONFIGS[reportKey].map(col => col.header)
                    }, {
                        responseType: 'blob',
                        headers: {
                            'Accept': 'application/octet-stream',
                            'Content-Type': 'application/json'
                        }
                    });

                    // Excel dosyasını tut
                    const blob = new Blob([response.data]);
                    setExcelFiles(prev => ({
                        ...prev,
                        [reportKey]: blob
                    }));

                    // Row count'u al ve stats'e kaydet
                    const rowCount = response.headers['x-row-count'];
                    const count = rowCount ? parseInt(rowCount) : 0;

                    setStats(prev => ({
                        ...prev,
                        [reportKey]: count
                    }));
                } else {
                    // Diğer raporlar için eski API
                    const response = await api.post('/report', {
                        start_date: moment(dateRange[0]).format('YYYY-MM-DD'),
                        end_date: moment(dateRange[1]).format('YYYY-MM-DD'),
                        warehouse_ids: id === 9 ? [] : warehouseIdsToUse,
                        report_id: id
                    });

                    setReportData(prev => ({
                        ...prev,
                        [reportKey]: response.data || []
                    }));

                    setStats(prev => ({
                        ...prev,
                        [reportKey]: Array.isArray(response.data) ? response.data.length :
                            (response.data?.data === null ? 0 : response.data?.data.length)
                    }));
                }

            } catch (error) {
                if (reportKey === 'saseList') {
                    // saseList için yeni hata yönetimi
                    const errorMessage = error.response?.data?.error || error.message || '';
                    console.error(errorMessage);
                    if (errorMessage.includes('empty data') || errorMessage.includes('failed to generate Excel')) {
                        setStats(prev => ({
                            ...prev,
                            [reportKey]: 0
                        }));
                        setExcelFiles(prev => {
                            const newState = { ...prev };
                            delete newState[reportKey];
                            return newState;
                        });
                    } else {
                        setStats(prev => ({
                            ...prev,
                            [reportKey]: 'Hata'
                        }));
                        setExcelFiles(prev => {
                            const newState = { ...prev };
                            delete newState[reportKey];
                            return newState;
                        });
                        let message = error.response?.data?.error || 'Beklenmedik bir hata oluştu';
                        toast.error(message + ` (${reportKey})`);
                    }
                } else {
                    // Diğer raporlar için eski hata yönetimi
                    console.error(`Error fetching ${reportKey} report:`, error);
                    setStats(prev => ({
                        ...prev,
                        [reportKey]: 'Hata'
                    }));
                    let message = error.response?.data?.error || 'Beklenmedik bir hata oluştu';
                    toast.error(message + ` (${reportKey})`);
                }
            } finally {
                setVisibleLoader(prev => ({
                    ...prev,
                    [reportKey]: false
                }));
            }
        };

        const reportPromises = Object.entries(REPORT_KEY).map(([key, id]) =>
            fetchReportWithWarehouses(key, id)
        );

        await Promise.allSettled(reportPromises);
    };

    const prepareExcelData = (data, reportKey) => {
        if (!data || !Array.isArray(data)) return [];

        const columnConfig = COLUMN_CONFIGS[reportKey];
        if (!columnConfig) return data;

        const dateColumns = [
            'unload_date', 'pdi_entry_date', 'pdi_exit_date', 'islem_tarihi',
            'fatura_bilgisi_tarihi', 'grupaj_yapildigi_tarih', 'pdi_cikis_tarihi',
            'tir_esleme_tarihi', 'fatura_tarihi', 'kapi_cikis_tarihi', 'permit_date',
            'blokaj_talep_tarihi', 'blokaj_kaldirma_tarihi', 'pdi_tarihi',
            'sevke_hazir_tarihi', 'sevk_tarihi', 'teslimat_tarihi', 'pdi_giris_tarihi',
            'yükleme_tarihi', 'resim_cekildigi_tarih',
            'park_giris_tarihi', 'tarih', 'grupaj_yapildigi_tarih'
        ];

        // Her satır için saatli kolonları da işaretle
        return data.map(row => {
            const newRow = {};
            newRow._hasTime = {}; // kolon bazında saat var mı?
            columnConfig.forEach(col => {
                let value = row[col.field];
                if (value && dateColumns.includes(col.field)) {
                    const momentDate = moment.utc(value);
                    if (momentDate.isValid()) {
                        newRow._hasTime[col.header] = /[T\s]\d{2}:\d{2}/.test(value); // saat var mı? (T veya boşluk ile ayrılmış)
                        value = momentDate.toDate();
                    }
                }
                newRow[col.header] = value;
            });
            return newRow;
        });
    };
    async function convertToExcel(datas) {
        let data = datas.data

        try {
            // JSON'u parse et
            const jsonData = {
                "data": data,
                "columns": [
                    { key: 'chassis_no', displayName: 'Şase No', type: 'text' },
                    { key: 'model', displayName: 'Model', type: 'text' },
                    { key: 'park_giris_tarihi', displayName: 'Park Giriş Tarihi', type: 'datetime' },
                    { key: 'depo_code', displayName: 'Depo Kodu', type: 'text' },
                    { key: 'bolge_code', displayName: 'Bölge Kodu', type: 'text' },
                    { key: 'tarih', displayName: 'Tarih', type: 'date' },
                    { key: 'resim_cekildigi_tarih', displayName: 'Resim Çekildiği Tarih', type: 'datetime' }
                ],
                "dateColumns": ["park_giris_tarihi", "tarih", "resim_cekildigi_tarih"]
            }
            // API'ye gönder
            const response = await api.post('/convertJsonToExcelStream', jsonData, {
                responseType: 'blob', // Yanıt türünü blob olarak belirt
            });

            // Dosyayı indir
            const blob = new Blob([response.data], { type: response.headers['content-type'] });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;

            // Dosya adını content-disposition header'ından al
            const contentDisposition = response.headers['content-disposition'];
            let filename = `veri_${new Date().toISOString().slice(0, 19).replace(/:/g, '-')}.xlsx`;
            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
                if (filenameMatch.length > 1) {
                    filename = filenameMatch[1];
                }
            }
            a.download = filename;

            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);

        } catch (error) {
            console.error('Hata:', error);
            throw error; // Hatayı yukarı fırlat
        }
    }
    const downloadExcel = async (reportKey, excel_name) => {
        try {
            // saseList için yeni indirme mantığı
            if (reportKey === 'saseList') {
                const rowCount = stats[reportKey];

                // Row count 0 ise indirme yapma
                if (rowCount === 0) {
                    toast.warning(`${excel_name} için indirilebilir veri bulunmuyor`);
                    return;
                }

                const excelFile = excelFiles[reportKey];

                if (!excelFile) {
                    toast.error('Excel dosyası bulunamadı. Lütfen önce "Listele" butonuna basın.');
                    return;
                }

                // İndirme başladığını belirt
                setDownloadingFiles(prev => ({
                    ...prev,
                    [reportKey]: true
                }));

                // Kısa bir gecikme ekle (kullanıcı deneyimi için)
                await new Promise(resolve => setTimeout(resolve, 500));

                // Dosyayı indir
                const url = window.URL.createObjectURL(excelFile);
                const a = document.createElement('a');
                a.href = url;
                a.download = `${excel_name}_${new Date().toISOString().slice(0, 19).replace(/:/g, '-')}.xlsx`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            } else {
                // Diğer raporlar için eski Excel indirme mantığı
                const data = reportData[reportKey]?.data;
                if (!data || !Array.isArray(data)) {
                    console.error('İndirilebilir veri bulunamadı');
                    return;
                }

                // Veriyi kolon konfigürasyonuna göre hazırla
                const preparedData = prepareExcelData(data, reportKey);

                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Rapor');

                // Başlık satırını ekle ve stil uygula
                const headers = Object.keys(preparedData[0]).filter(h => h !== '_hasTime');
                const headerRow = worksheet.addRow(headers);

                worksheet.autoFilter = {
                    from: { row: 1, column: 1 },
                    to: { row: 1, column: headers.length }
                };

                // Başlık stilini uygula
                headerRow.eachCell((cell) => {
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: '4472C4' },
                    };
                    cell.font = { color: { argb: 'FFFFFF' }, bold: true };
                    cell.alignment = { horizontal: 'center', vertical: 'middle' };
                    cell.border = {
                        top: { style: 'thin', color: { argb: 'D9D9D9' } },
                        left: { style: 'thin', color: { argb: 'D9D9D9' } },
                        bottom: { style: 'thin', color: { argb: 'D9D9D9' } },
                        right: { style: 'thin', color: { argb: 'D9D9D9' } },
                    };
                });

                // Veri satırlarını ekle ve stil uygula
                preparedData.forEach((row, index) => {
                    const excelRow = worksheet.addRow(headers.map(h => row[h]));
                    const isEvenRow = index % 2 === 0;

                    excelRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
                        const header = headers[colNumber - 1];
                        // Tarih formatını ayarla
                        if (row[header] instanceof Date) {
                            if (row._hasTime && row._hasTime[header]) {
                                cell.numFmt = 'dd.mm.yyyy hh:mm';
                            } else {
                                cell.numFmt = 'dd.mm.yyyy';
                            }
                        }
                        cell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: isEvenRow ? 'F2F2F2' : 'FFFFFF' }
                        };
                        cell.alignment = { horizontal: 'center', vertical: 'middle' };
                        cell.border = {
                            top: { style: 'thin', color: { argb: 'D9D9D9' } },
                            left: { style: 'thin', color: { argb: 'D9D9D9' } },
                            bottom: { style: 'thin', color: { argb: 'D9D9D9' } },
                            right: { style: 'thin', color: { argb: 'D9D9D9' } },
                        };
                    });
                });

                worksheet.getRow(1).eachCell((cell) => {
                    cell.protection = {
                        locked: true,
                        autoFilter: true
                    };
                });

                // Sütun genişliklerini otomatik ayarla
                worksheet.columns.forEach((column, index) => {
                    const maxLength = Math.max(
                        ...worksheet.getColumn(index + 1).values
                            .filter(value => value)
                            .map(value => value.toString().length)
                    );
                    column.width = Math.min(Math.max(maxLength + 2, 15), 30);
                });

                // Excel dosyasını kaydet
                const filename = `${excel_name}_${moment().format('YYYY-MM-DD HH:mm:ss')}.xlsx`;
                workbook.xlsx.writeBuffer().then((buffer) => {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), filename);
                });
            }
        } catch (error) {
            console.error('Excel indirme hatası:', error);
            if (reportKey === 'saseList') {
                toast.error('Excel dosyası indirilirken hata oluştu');
            }
        } finally {
            if (reportKey === 'saseList') {
                // İndirme durumunu sıfırla
                setDownloadingFiles(prev => ({
                    ...prev,
                    [reportKey]: false
                }));
            }
        }
    };

    const StatsCard = ({ title, value, color, keyA, excel_name }) => (
        <Card className="mb-4" style={{
            background: `linear-gradient(135deg, ${color}25, ${color}40)`,
            border: 'none',
            boxShadow: `0 4px 6px ${color}15`,
            transition: 'transform 0.2s, box-shadow 0.2s',
            ':hover': {
                transform: 'translateY(-5px)',
                boxShadow: `0 6px 8px ${color}25`
            }
        }}>
            <CardBody className="text-center position-relative" style={{
                borderLeft: `4px solid ${color}`,
                padding: '1.5rem'
            }}>
                <>
                    <h2 className="mb-3" style={{
                        fontSize: '2.5rem',
                        fontWeight: '700',
                        fontFamily: 'Roboto Mono, monospace',
                        color: '#1a202c',
                        position: 'relative',
                        zIndex: 1
                    }}>
                        {
                            visibleLoader[keyA] ? <LoadIndicator width="40px" height="40px" /> : value === 'Hata' ? 'Hata' : value === null ? "-" : value
                        }
                    </h2>
                    <p style={{
                        fontSize: '1rem',
                        fontWeight: '600',
                        letterSpacing: '0.025em',
                        color: '#2d3748',
                        marginBottom: 0
                    }}>
                        {
                            visibleLoader[keyA] ? 'Yükleniyor...' : title?.toLocaleUpperCase('tr-TR')
                        }
                    </p>
                </>
            </CardBody>
            <CardFooter
                onClick={() => (value !== null && value !== 'Hata' && value !== 0) ? downloadExcel(keyA, excel_name) : null}
                style={{
                    background: `${color}30`,
                    borderTop: `1px solid ${color}50`,
                    padding: '0.75rem',
                    cursor: (value !== null && value !== 'Hata' && value !== 0) ? 'pointer' : 'not-allowed',
                    opacity: (value !== null && value !== 'Hata' && value !== 0) ? 1 : 0.5,
                    transition: 'all 0.3s'
                }}
                onMouseEnter={(e) => {
                    if (value !== null && value !== 'Hata' && value !== 0) {
                        e.currentTarget.style.background = `${color}50`;
                    }
                }}
                onMouseLeave={(e) => {
                    if (value !== null && value !== 'Hata' && value !== 0) {
                        e.currentTarget.style.background = `${color}30`;
                    }
                }}
            >
                <div className="text-center">
                    {(keyA === 'saseList' && downloadingFiles[keyA]) ? (
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                            <LoadIndicator width="16px" height="16px" />
                            <span style={{
                                fontSize: '0.875rem',
                                color: '#2d3748',
                                fontWeight: '600'
                            }}>
                                İndiriliyor...
                            </span>
                        </div>
                    ) : (
                        <span style={{
                            fontSize: '0.875rem',
                            color: '#2d3748',
                            fontWeight: '600'
                        }}>
                            Excele İndir &nbsp; <i className="fa fa-download"></i>
                        </span>
                    )}
                </div>
            </CardFooter>
        </Card>
    );

    return (
        <>
            <Breadcrumb current="Raporlar" />
            <div className="p-4" style={{ background: '#f8fafc' }}>
                <Card className="mb-6" style={{
                    background: 'white',
                    border: 'none'
                }}>
                    <CardBody className="">
                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-4">
                            <div style={{ minWidth: '250px' }}>
                                <DateRangeBox
                                    value={dateRange}
                                    onValueChanged={handleDateChange}
                                    showClearButton={true}
                                    placeholder="Rapor Tarih Aralığı"
                                    displayFormat={"dd/MM/yyyy"}

                                />
                            </div>
                            <div className="d-flex align-items-center justify-content-end" style={{ flex: 1, gap: "5px" }}>
                                <div style={{ flex: 1, maxWidth: '400px' }}>
                                    <TagBox
                                        dataSource={warehouses}
                                        displayExpr="warehouse_name"
                                        valueExpr="id"
                                        placeholder="Depo Seçiniz"
                                        value={selectedWarehouse}
                                        onValueChanged={handleWarehouseChange}
                                    />
                                </div>
                                <div>
                                    <Button
                                        type="default"
                                        onClick={handleListele}
                                        disabled={warehouses.length === 0}
                                        color="success"
                                        style={{
                                            color: 'white',
                                            height: '40px',
                                            border: 'none',
                                            fontWeight: '500',
                                            transition: 'all 0.3s'
                                        }}
                                    >
                                        <i className="fa fa-list m-0" /> &nbsp;
                                        Listele
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </CardBody>
                </Card>

                <div className="p-4 card">
                    <Row>
                        <Col md={3}>
                            <StatsCard
                                keyA="shipmentPending"
                                excel_name="Gemi Tahliye Listesi"
                                title="Gemi Tahliye Listesi"
                                value={stats.shipmentPending}
                                color="#22c55e"
                            />
                        </Col>
                        <Col md={3}>
                            <StatsCard
                                keyA="pdiIncoming"
                                excel_name="PDI Giriş Listesi"
                                title="PDI Giriş Listesi"
                                value={stats.pdiIncoming}
                                color="#0ea5e9"
                            />
                        </Col>
                        <Col md={3}>
                            <StatsCard
                                keyA="pdiOutgoing"
                                excel_name="PDI Çıkış Listesi"
                                title="PDI Çıkış Listesi"
                                value={stats.pdiOutgoing}
                                color="#f97316"
                            />
                        </Col>
                        <Col md={3}>
                            <StatsCard
                                keyA="warehouseOutgoing"
                                excel_name="Depo Çıkış Listesi"
                                title="Depo Çıkış Listesi"
                                value={stats.warehouseOutgoing}
                                color="#6366f1"
                            />
                        </Col>
                        <Col md={3}>
                            <StatsCard
                                keyA="warehouseIncoming"
                                excel_name="Depo Giriş Listesi"
                                title="Depo Giriş Listesi"
                                value={stats.warehouseIncoming}
                                color="#0284c7"
                            />
                        </Col>
                        <Col md={3}>
                            <StatsCard
                                keyA="fatura"
                                excel_name="Fatura Listesi"
                                title="Fatura Listesi"
                                value={stats.fatura}
                                color="#6d28d9"
                            />
                        </Col>
                    </Row>
                </div>
            </div>
        </>
    );
};

export default RaporlarMusteri;